// Tokens are replaced by the CI pipeline at deploy time.
export const environment = {
  production: false,
  apiUrl: '#{apiUrl}#',
  auth: {
    clientId: '#{msalClientId}#',
    authority: '#{msalAuthority}#',
    scope: '#{msalScope}#',
    defaultIdentityProvider: '#{msalDefaultIdp}#',
  },
};
